export default __webpack_public_path__ + "9dcbb74975dd5bb3a98e6f76fa722543.svg";